<template>
  <div
    v-if="showCTAActions"
    :class="[
      'subscription-banner',
      'subscriptions__cta-wrapper',
      isFreeTrialPlan && 'subscriptions__cta-wrapper--trial',
    ]"
  >
    <div class="subscription-banner__data-container">
      <div class="subscription-banner__text">
        <h6
          :id="bannerData.id"
          :class="[
            'subscription-banner__text-title',
            isFreeTrialPlan && 'subscription-banner__text-title--trial',
          ]"
        >
          {{ bannerData.text }}
        </h6>
        <div v-if="bannerData.info" class="subscription-banner__text-info">
          {{ bannerData.info }}
        </div>
      </div>
      <a
        v-if="isPremiumPlan"
        href="//ine.com/business-solutions"
        class="btn btn--primary subscription-banner__button"
      >
        Upgrade now
      </a>
      <a
        v-if="(isMonthlyPlan || isAnnualPlan) && !isFreeTrialPlan"
        @click="$emit('show-premium-upgrade-modal')"
        class="btn btn--primary subscription-banner__button"
      >
        Upgrade now
      </a>
      <a
        v-if="isFreeTrialPlan"
        @click="$emit('show-upgrade-modal')"
        class="btn btn--primary subscription-banner__button"
      >
        Upgrade now
      </a>
      <a
        v-if="isTrialCancelBtnAvailable"
        @click="$emit('cancel-subscription-renewal', userCurrentPlan.plan)"
        class="btn btn--tertiary subscription-banner__button subscription-banner__button--cancel"
      >
        Cancel trial
      </a>
    </div>
    <div v-if="!isFreeTrialPlan" class="subscription-banner__pill">
      {{ bannerData.label }}
    </div>
  </div>
</template>

<script>
import {
  formatSubTrialDate,
  formatSubDate,
  getDaysRemainingForTrialSub,
} from '@/helpers'

export default {
  name: 'CTAActions',
  props: {
    userCurrentPlan: {
      type: Object,
      required: true,
    },
    premiumPlanCodes: {
      type: Object,
      required: true,
    },
    annualPlanCode: {
      type: String,
      required: true,
    },
    monthlyPlanCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      bannerData: {
        text: '',
        info: '',
        id: '',
        label: '',
      },
    }
  },
  computed: {
    isPremiumPlan() {
      return (
        Object.values(this.premiumPlanCodes).includes(
          this.userCurrentPlan.plan_code
        ) && !this.isFreeTrialPlan
      )
    },
    isAnnualPlan() {
      return this.userCurrentPlan.plan_code === this.annualPlanCode
    },
    isMonthlyPlan() {
      return this.userCurrentPlan.plan_code === this.monthlyPlanCode
    },
    isFreeTrialPlan() {
      return (
        !!this.userCurrentPlan.plan?.trial_started_at &&
        !!this.userCurrentPlan.plan?.trial_ends_at
      )
    },
    freeTrialPlanDaysRemaining() {
      return getDaysRemainingForTrialSub(this.userCurrentPlan.plan)
    },
    freeTrialLabel() {
      if (!this.isFreeTrialPlan) return ''
      const days_remaining = this.freeTrialPlanDaysRemaining
      if (days_remaining < 0) return 'EXPIRED'
      if (days_remaining === 0) return 'EXPIRES TODAY'
      return `${getDaysRemainingForTrialSub(
        this.userCurrentPlan.plan
      )} days remaining`
    },
    freeTrialInfo() {
      if (!this.isFreeTrialPlan) return ''
      const days_remaining = this.freeTrialPlanDaysRemaining
      if (days_remaining < 0)
        return `Your free trial has expired on ${formatSubDate(
          this.userCurrentPlan.plan.trial_ends_at
        )}`
      if (days_remaining === 0) return 'Yout free trial expires today'
      return `Your free trial expires on ${formatSubTrialDate(
        this.userCurrentPlan.plan.trial_ends_at
      )}`
    },
    isTrialCancelBtnAvailable() {
      return this.isFreeTrialPlan && this.freeTrialPlanDaysRemaining > -1
    },
    showCTAActions() {
      return !!this.bannerData.text
    },
  },
  created() {
    if (this.isFreeTrialPlan) {
      this.bannerData.text = 'You have a '
      this.bannerData.id = 'free_trial'
      this.bannerData.label = this.freeTrialLabel
      this.bannerData.info = this.freeTrialInfo

      if (this.isPremiumPlan) this.bannerData.text += 'Premium'
      else if (this.isMonthlyPlan)
        this.bannerData.text += 'Fundamentals Monthly'
      else if (this.isAnnualPlan) this.bannerData.text += 'Fundamentals Annual'

      this.bannerData.text += ' 7 Day Trial'
    } else {
      if (this.isPremiumPlan) {
        this.bannerData.text =
          'Train your dream team with an INE Business Account'
        this.bannerData.id = 'premium'
        this.bannerData.label = 'INE for Business'
      }
      if (this.isAnnualPlan) {
        this.bannerData.text =
          'Get access to Bootcamps when you upgrade to a Premium Account'
        this.bannerData.id = 'annual'
        this.bannerData.label = 'Premium Plan'
      }
      if (this.isMonthlyPlan) {
        this.bannerData.text = 'Save 15% when you upgrade to an Annual Account'
        this.bannerData.id = 'monthly'
        this.bannerData.label = 'Annual Plan'
      }
    }
  },
}
</script>
